// extracted by mini-css-extract-plugin
export default {"imgdiv":"_1d526cc5b0 d2b01b79b9","img":"f555c5181a _2b8c94080b"};